import { create } from "zustand";

type DataProduct = {
  idProduct?: number;
  typeOfProduct?: string;
  typeAlert?: string;
  showSplashNotification: boolean;
};

type State = {
  // idProduct: number | string;
  // typeProductStore: string;
  // typeAlert: string;
  giveValue: DataProduct;
  revertValue: DataProduct;
};

type Actions = {
  setGiveValue: (value: DataProduct) => void;
  setRevertValue: (value: DataProduct) => void;
};

export const useSplashNotificationStore = create<State & Actions>((set) => ({
  giveValue: {
    idProduct: 0,
    typeOfProduct: "",
    typeAlert: "",
    showSplashNotification: false,
  },
  revertValue: {
    idProduct: 0,
    typeOfProduct: "",
    typeAlert: "",
    showSplashNotification: false,
  },
  setRevertValue: (state: DataProduct) => set(() => ({ revertValue: state })),
  setGiveValue: (value: DataProduct) => {
    set(() => ({ giveValue: value }));
    if (value.showSplashNotification) {
      setTimeout(() => {
        set(() => ({
          giveValue: {
            idProduct: 0,
            typeOfProduct: "",
            typeAlert: "",
            showSplashNotification: false,
          },
        }));
      }, 3000);
    }
  },
}));
